import type { SalesOrder } from '../../../../domain/types'
import { SalesOrderCard } from './sales-order-card'

interface SalesOrdersCardViewProps {
  salesOrders: SalesOrder[]
  showTenantColumn?: boolean
  onView: (salesOrder: SalesOrder) => void
  onReorder: (salesOrder: SalesOrder) => void
  onCancel: (salesOrder: SalesOrder) => void
}

export function SalesOrdersCardView({
  salesOrders,
  showTenantColumn,
  onView,
  onReorder,
  onCancel,
}: SalesOrdersCardViewProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
      {salesOrders.map((salesOrder) => (
        <SalesOrderCard
          key={salesOrder.id}
          salesOrder={salesOrder}
          showTenantColumn={showTenantColumn}
          onView={onView}
          onReorder={onReorder}
          onCancel={onCancel}
        />
      ))}
    </div>
  )
}
